import React from 'react';
import PropTypes from 'prop-types';
import 'nvd3/build/nv.d3.css';

import Header from './Header';
import Legend from './Legend';
import './styles.css';

export default function Chart({ title, data, children, id }) {
  return data.length > 0 ? (
    <div id={id} className="pie-data-container" data-cy="pie-data-container">
      <div className="pie-chart-container">
        <Header title={title} />
        {children}
      </div>
      <Legend data={data} />
    </div>
  ) : null;
}

Chart.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
  data: PropTypes.array,
  children: PropTypes.node,
};
